// Display preferences — small zustand store with localStorage persistence.
// Currently tracks the fee-adjusted-odds toggle on the Value Dashboard.

import { create } from 'zustand';

const STORAGE_KEY = 'galactus:displaySettings';

interface PersistedShape {
  feeAdjustedOdds: boolean;
}

const DEFAULTS: PersistedShape = {
  feeAdjustedOdds: true,
};

function read(): PersistedShape {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<PersistedShape>;
    return { feeAdjustedOdds: parsed.feeAdjustedOdds ?? DEFAULTS.feeAdjustedOdds };
  } catch {
    return { ...DEFAULTS };
  }
}

function write(s: PersistedShape) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
  } catch {
    // localStorage full or unavailable — silent
  }
}

interface DisplaySettingsStore extends PersistedShape {
  toggleFeeAdjustedOdds: () => void;
}

export const useDisplaySettings = create<DisplaySettingsStore>((set, get) => ({
  ...read(),
  toggleFeeAdjustedOdds: () => {
    const next = !get().feeAdjustedOdds;
    set({ feeAdjustedOdds: next });
    write({ feeAdjustedOdds: next });
  },
}));
